document.addEventListener('DOMContentLoaded', () => {
    let mm = gsap.matchMedia()
    mm.add("(min-width: 768px)", () => {
        // Анимация цифр
        const digitsList = document.querySelectorAll('.animated-num__value-digits')
        if (digitsList.length) {
            digitsList.forEach((digits) => {
                // Получаем исходное число и форматируем его с разделителями тысяч
                const originalNumber = digits.innerHTML.trim().replace(/\s/g, '');
                const formattedNumber = new Intl.NumberFormat('ru-RU').format(originalNumber);
                const symbolsArr = formattedNumber.split('')

                digits.innerHTML = ''
                symbolsArr.forEach((el) => {
                    const digitTrack = document.createElement("div")
                    digitTrack.classList.add('animated-num__value-digits-track')

                    // Если это разделитель (не цифра), просто добавляем его
                    if (isNaN(parseInt(el))) {
                        const separator = document.createElement("span")
                        separator.classList.add('animated-num__value-separator')
                        separator.textContent = el
                        digitTrack.appendChild(separator)
                    } else {
                        const digitsArr = []
                        const val = parseInt(el)
                        for (let i = val - 6; i <= val; i++) {
                            digitsArr.push(Math.abs(i))
                        }
                        digitsArr.forEach((n) => {
                            const digit = document.createElement("span")
                            digit.classList.add('animated-num__value-digit')
                            digit.textContent = n
                            digitTrack.appendChild(digit)
                        })
                    }

                    digits.appendChild(digitTrack);
                })

                digits.closest('.animated-num').style.opacity = 1
            })


            digitsList.forEach((box) => {
                const trackList = box.querySelectorAll('.animated-num__value-digits-track')

                trackList.forEach((track, index) => {
                    // Пропускаем анимацию для разделителей
                    if (track.querySelector('.animated-num__value-separator')) return;

                    let observer = new IntersectionObserver((entries) => {
                        entries.forEach((entry) => {
                            if (entry.isIntersecting) {
                                gsap.to(track, {
                                    duration: .6 + index / 5 + Math.random(),
                                    yPercent: -600,
                                    opacity: 1,
                                })
                            }
                        });
                    }, { threshold: .2 })
                    observer.observe(box)
                })
            })
        }
    })
})



